import React from "react";
import { FiPhone, FiMail, FiClock } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";

const TopMarquee = () => {
  const marqueeItems = [
    {
      icon: <FiPhone className="text-amber-300 text-sm flex-shrink-0" />,
      label: "CALL US",
      value: "+91 6752455372",
      link: "tel:+916752455372",
    },
    {
      icon: <FiMail className="text-amber-300 text-sm flex-shrink-0" />,
      label: "EMAIL US",
      value: "pcmexportsbbsr@gmail.com",
      link: "mailto:pcmexportsbbsr@gmail.com",
    },
    {
      icon: <FaWhatsapp className="text-green-400 text-sm flex-shrink-0" />,
      label: "WHATSAPP",
      value: "+91 9776908224",
      link: "https://wa.me/919776908224",
    },
    {
      icon: <FiClock className="text-amber-300 text-sm flex-shrink-0" />,
      label: "WORKING HOURS",
      value: "Mon - Sun, 9:00 AM - 6:00 PM",
      link: null,
    },
  ];

  return (
    <div className="w-full bg-[#2A0E15] text-white py-1.5 px-4 overflow-hidden border-b border-white/10 z-50 text-xs select-none">
      <style>{`
        @keyframes marquee-left-to-right {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0%); }
        }
        .animate-marquee-ltr {
          display: flex;
          width: max-content;
          animation: marquee-left-to-right 28s linear infinite;
        }
        .animate-marquee-ltr:hover {
          animation-play-state: paused;
        }
      `}</style>
      <div className="animate-marquee-ltr flex items-center gap-12">
        {/* Render duplicate sets for seamless loop */}
        {[...marqueeItems, ...marqueeItems, ...marqueeItems, ...marqueeItems].map((item, index) => (
          <div key={index} className="flex items-center gap-2 flex-shrink-0">
            {item.icon}
            <span className="font-bold tracking-wider text-[11px] text-amber-200 uppercase">
              {item.label}:
            </span>
            {item.link ? (
              <a
                href={item.link}
                target={item.link.startsWith("http") ? "_blank" : "_self"}
                rel="noreferrer"
                className="font-medium text-gray-100 hover:text-amber-300 transition"
              >
                {item.value}
              </a>
            ) : (
              <span className="font-medium text-gray-100">{item.value}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopMarquee;
